import BaseModel from './BaseModel'

export default class Tag extends BaseModel {
  // ... Tag-specific methods or overrides ...
}
